// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__F6V02","loading":"Loading_loading__kRh6P","spinner":"Loading_spinner__EQtTp","content":"Loading_content__4Pzw5"};